import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import AmountPrice from '../../Components/AmountPrice/AmountPrice';
import AmountPriceContainer from '@configuratorware/configurator-frontendgui/App/Screens/Configurator/Containers/AmountPrice';
import { setVisible } from '@configuratorware/configurator-frontendgui/App/Reducers/UI/Actions';
import { Services } from '@configuratorware/configurator-frontendgui/App/ServiceLocator';

const CustomAmountPriceContainer = (props) => {
  const dispatch = useDispatch();
  const { code, configurationType } = useSelector((state) => state.configurator.configuration);
  const { calculation } = useSelector((state) => state.configurator);
  const { orientation } = useSelector((state) => state.device.screen);
  const netTotalFormatted = calculation ? calculation.netTotalFormatted : '';
  const bulkPrices = calculation && calculation.bulkPrices ? calculation.bulkPrices : [];

  return (
    <AmountPriceContainer
      {...props}
      Component={AmountPrice}
      code={code}
      configurationType={configurationType}
      updateGlobalLoader={(flag) => dispatch(setVisible('globalLoader', flag))}
      bulkPrices={bulkPrices}
      netTotalFormatted={netTotalFormatted}
      orientation={orientation}
      saveConfiguration={() => Services.interaction.saveAndReturn()}
    />
  );
};

export default CustomAmountPriceContainer;
